import { Controller } from '@hotwired/stimulus';
import { formatPriceForSelectedCurrency, getPricingForParticipants, HOSTING_PLUS_PER_PERSON } from '../utilities/pricing';

export default class extends Controller {
  static targets = [
    'participantsInput',
    'participants',
    'price',
    'hostingFee',
    'hostingFeeDiv',
    'participantSubtotal',
    'kitSubtotal',
    'platformFee',
    'transactionFee',
    'total',
    'pricingDiv',
    'unsupportedDiv',
    'kitFee',
    'kitFeeDiv',
    'showKitDiv',
  ];

  static values = {
    priceDetails: Object,
    maxParticipants: Number,
    minParticipants: Number,
    chargePlatformFee: Number,
  };

  connect() {
    this.updatePrices();
    this.toggleHostingFeeVisibility();
  }

  updatePrices() {
    const participants = this.participantsInputTarget.value;
    this.participantsTargets.forEach((el) => el.innerHTML = participants);
    const showKit = this.showKitDivTarget.querySelector('#booking_with_kits').checked;

    const priceDetails = getPricingForParticipants(
      this.priceDetailsValue,
      participants,
      this.chargePlatformFeeValue,
      showKit,
    );

    this.togglePricingDiv();
    if (priceDetails) {
      this.priceTarget.innerHTML = formatPriceForSelectedCurrency(priceDetails.price);
      this.hostingFeeTarget.innerHTML = formatPriceForSelectedCurrency(priceDetails.hostingFee);
      this.participantSubtotalTarget.innerHTML = formatPriceForSelectedCurrency(priceDetails.participantSubtotal);
      this.platformFeeTarget.innerHTML = formatPriceForSelectedCurrency(priceDetails.platformFee);
      this.transactionFeeTarget.innerHTML = formatPriceForSelectedCurrency(priceDetails.transactionFee);
      if (priceDetails.kitPrice && showKit) {
        this.showKitFees();
        this.kitSubtotalTarget.innerHTML = formatPriceForSelectedCurrency(priceDetails.kitSubtotal);
        this.kitFeeTarget.innerHTML = formatPriceForSelectedCurrency(priceDetails.kitPrice);
      } else {
        this.hideKitFees();
      }
      this.totalTarget.innerHTML = formatPriceForSelectedCurrency(priceDetails.total);
    } else {
      this.priceTarget.innerHTML = '';
      this.hostingFeeTarget.innerHTML = '';
      this.subtotalTarget.innerHTML = '';
      this.platformFeeTarget.innerHTML = '';
      this.transactionFeeTarget.innerHTML = '';
      this.totalTarget.innerHTML = '';
    }
  }

  togglePricingDiv() {
    if (this.participantsTarget.innerHTML.length === 0) {
      return;
    }

    const overMaxParticipants = this.participantsTarget.innerHTML > this.maxParticipantsValue;
    const underMinParticipants = this.participantsTarget.innerHTML < this.minParticipantsValue;

    if (overMaxParticipants || underMinParticipants) {
      this.unsupportedDivTarget.classList.remove('hidden');
      this.pricingDivTarget.classList.add('hidden');
    } else {
      this.unsupportedDivTarget.classList.add('hidden');
      this.pricingDivTarget.classList.remove('hidden');
    }
  }

  hideKitFees() {
    if (this.hasKitFeeDivTarget) {
      this.kitFeeDivTarget.classList.add('hidden');
    }
  }

  showKitFees() {
    if (this.hasKitFeeDivTarget) {
      this.kitFeeDivTarget.classList.remove('hidden');
    }
  }

  toggleHostingFeeVisibility() {
    if (this.priceDetailsValue.kind !== HOSTING_PLUS_PER_PERSON) {
      this.hostingFeeDivTarget.classList.add('hidden');
    } else {
      this.hostingFeeDivTarget.classList.remove('hidden');
    }
  }
}
